import { PageTypeEnum } from 'common/enums/PageTypeEnum'

export const pagesWithAutomationRulesTypes = [
  PageTypeEnum.Squeeze,
  PageTypeEnum.OptInThankYou,
  PageTypeEnum.Popup,
  PageTypeEnum.Inline,
  PageTypeEnum.SalesPage,
  PageTypeEnum.OfferThankYouPage,
  PageTypeEnum.InfoPage,
  PageTypeEnum.BlogHome,
  PageTypeEnum.BlogStatic,
  PageTypeEnum.BlogSearch,
  PageTypeEnum.BlogPostListing,
]
